import generateBasicEntityActions from './generateBasicEntityActions';

const triggerTypeActions = generateBasicEntityActions('triggerTypes', 'triggerType');

export default triggerTypeActions;
